import React from "react";
import { Snackbar, Alert, useTheme, useMediaQuery } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

export type ToastType = "success" | "error";

interface ReusableToastProps {
  isOpen: boolean;
  type: ToastType;
  message: string;
  onClose: () => void;
}

const ReusableToast: React.FC<ReusableToastProps> = ({
  isOpen,
  type,
  message,
  onClose,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const icon =
    type === "success" ? (
      <CheckCircleIcon
        sx={{
          fill: "#2e7d32",
        }}
      />
    ) : (
      <ErrorIcon
        sx={{
          fill: "#5F1C15",
        }}
      />
    );
  const color = type === "success" ? "#2e7d32" : "#F71600";

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={3000}
      onClose={onClose}
      sx={{
        bottom: isMobile ? "100px!important" : "180px!important",
        zIndex: 10000,
      }}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        onClose={onClose}
        // severity={color}
        icon={icon}
        variant="filled"
        sx={{
          backgroundColor: "#1E1E1E",
          border: `solid 0.5px ${color}!important`,
          color: "#fff",
          borderRadius: "8px",
          boxShadow: "none",
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
          fontWeight: 500,
          fontSize: "0.875rem",
          lineHeight: 1.43,
          letterSpacing: "0.01071em",
          display: "flex",
          alignItems: "start",
          padding: "6px 16px",
          transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
          width: "85%",
          maxWidth: "95%",
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default ReusableToast;
